"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:7.0.0'] && _();
}
catch (e) { }
